import './pick-file-button.scss';
import RingButton from '@jetbrains/ring-ui/components/button-ng/button-ng';

export default angular.module('installer.pick-file-button', [RingButton]).
  directive('pickFileButton', () => ({
    restrict: 'E',
    template: `
        <rg-button ng-class="className" loader="loader">
          <input class="pick-file-button__input js-file-input" type="file"/>
          {{buttonText}}
        </rg-button>
      `,
    scope: {
      className: '@',
      buttonText: '@',
      onFileChosen: '&',
      loader: '=?'
    },
    link(scope, iElement, iAttrs) {
      const element = iElement[0];
      const fileInput = element.querySelector('.js-file-input');
      scope.buttonText = iAttrs.buttonText;

      iElement[0].addEventListener('click', () => {
        if (fileInput.click) {
          fileInput.click();
        } else {
          throw new Error('Your browser doesn\'t support HTMLElement.click');
        }
      });

      fileInput.addEventListener('change', () => {
        const reader = new FileReader();

        reader.onload = e => {
          scope.$applyAsync(() => {
            const fileContent = e.target.result;
            scope.onFileChosen({fileContent});
          });
        };

        reader.readAsText(fileInput.files[0]);
      });
    }
  }));



// WEBPACK FOOTER //
// ./src/blocks/pick-file-button/pick-file-button.js